import { render, staticRenderFns } from "./OrganizationDetailsFields.vue?vue&type=template&id=1bf6a49c&"
import script from "./OrganizationDetailsFields.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetailsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports